import { getDaysTillGoalDate, getLocalizedDateLabel } from "../helpers"

export default (getView) =>
  ({ nextStepPath, formFields, redirectIfWeightGainUrl }) => ({
    ...getView({
      nextStepPath,
      formFields,
      redirectIfWeightGainUrl,
    }),

    defaultGoalPaceKg: 0.25,
    defaultGoalPaceLbs: 0.5,
    initContentHidden: true,

    init() {
      this.commonInit()

      this.formValues.goalPaceKg = this.formValues.goalPaceKg || this.defaultGoalPaceKg
      this.formValues.goalPaceLbs = this.formValues.goalPaceLbs || this.defaultGoalPaceLbs
    },

    handleInput($event, field) {
      this.formValues[field] = Number($event.target.value)
      this.convertGoalPace()
    },

    convertGoalPace() {
      if (this.isMetric()) {
        this.formValues.goalPaceLbs = this.formValues.goalPaceKg * 2
      }
      if (this.isImperial()) {
        this.formValues.goalPaceKg = this.formValues.goalPaceLbs / 2
      }
    },

    getGoalDateLabel(isIncludeYear) {
      const isMetric = this.isMetric()
      // Use already stored used data
      const { weightKg, weightLbs, targetWeightKg, targetWeightLbs } = this.store.values
      // Use dynamic form data for UI
      const { goalPaceKg, goalPaceLbs } = this.formValues

      const daysTillGoalDate = getDaysTillGoalDate(
        {
          weightKg,
          weightLbs,
          targetWeightKg,
          targetWeightLbs,
          goalPaceKg,
          goalPaceLbs,
        },
        isMetric
      )

      const goalDate = new Date()
      goalDate.setDate(goalDate.getDate() + daysTillGoalDate)

      return getLocalizedDateLabel(goalDate, isIncludeYear)
    },
  })
